import React, { createContext, useContext, useState } from 'react';

interface PopoverContextType {
  openId: string | null;
  anchorEl: HTMLElement | null;
  setPopover: (id: string | null, anchor: HTMLElement | null) => void;
  closePopover: () => void;
}

const PopoverContext = createContext<PopoverContextType | undefined>(undefined);

export const PopoverProvider: React.FC<{ children: React.ReactNode }> = ({ children }) => {
  const [openId, setOpenId] = useState<string | null>(null);
  const [anchorEl, setAnchorEl] = useState<HTMLElement | null>(null);

  const setPopover = (id: string | null, anchor: HTMLElement | null) => {
    if (openId === id && anchorEl === anchor) {
      setOpenId(null);
      setAnchorEl(null);
    } else {
      setOpenId(id);
      setAnchorEl(anchor);
    }
  };

  const closePopover = () => {
    setOpenId(null);
    setAnchorEl(null);
  };

  return (
    <PopoverContext.Provider value={{ openId, anchorEl, setPopover, closePopover }}>
      {children}
    </PopoverContext.Provider>
  );
};

export const usePopover = () => {
  const context = useContext(PopoverContext);
  if (!context) {
    throw new Error('usePopover must be used within a PopoverProvider');
  }
  return context;
};
